export default __webpack_public_path__ + "static/publicis-conseil-share-b9c9d9c5c42fdf2b5bfc9a3bcff4fae1.png";